import { post } from 'services/http';

const getRecipes = problemTypes => post('/recipes', { problemTypes }, { addKgId: true });

export default {
  getRecipes
};
